/**
 * @generated SignedSource<<00e3a17a194758216764d13be4de41d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly$data = {
  readonly monthlyTeamSchedule: {
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentList_teamSchedule" | "WidgetTeamScheduleContentSectionHeader_teamSchedule" | "WidgetTeamScheduleContentStatus_teamSchedule">;
  };
  readonly " $fragmentType": "WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly";
};
export type WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly$key = {
  readonly " $data"?: WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamSchedule",
      "kind": "LinkedField",
      "name": "monthlyTeamSchedule",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleContentList_teamSchedule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleContentSectionHeader_teamSchedule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleContentStatus_teamSchedule"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTeamScheduleContentMonthly",
  "abstractKey": null
};

(node as any).hash = "ac22be832d08fb4c870c7ef68884bf68";

export default node;
